import { formatBusinessDate } from "@/utils/datetime";

// Respect the same date-format preference as the project record.
export function formatBoardDate(value) { return formatBusinessDate(value); }
